/**
 * If IRRIGATION flag is set, or if the METRC flag is not set, return
 * @type {function}
 * @param {Object} flags
 * @returns {boolean}
 */
export const IRRIGATION_OR_NOT_METRC = ({ IRRIGATION, METRC }) => Boolean(IRRIGATION || !METRC)
